import { TYPE_NUMBER } from './input-types';

export const id = 'orderTotal';
export const apiKey = 'OrderTotal';
export const type = TYPE_NUMBER;

export const orderTotal = {
  id,
  apiKey,
  type,
};
